import {FC} from "react";
import {ICaseWeakSignals} from "../../../pages/Fintech/FintechDashboard.type";
import {CaseItemWeakSignal} from "./CaseItemWeakSignal";

interface Iprops {
  dataCases: ICaseWeakSignals;
}

interface IItem {
  id: number;
  name: string;
  desc: string;
  url: string;
}

export const BlockCaseWeakSignals: FC<Iprops> = ({dataCases}) => {
  const dataItem: IItem = {
    id: 1,
    name: dataCases.case_name,
    desc: dataCases.case_details,
    url: dataCases.case_url,
  };
  return (
    <>
      <div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          ></div>
        </div>
        <CaseItemWeakSignal dataItem={dataItem} isOpen={true} />
      </div>
    </>
  );
};
